// src/components/Navbar.jsx

import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import AddIcon from "../assets/add.png";
import SearchIcon from "../assets/search.png";
import UsersIcon from "../assets/users.png";
import LogoutIcon from "../assets/logout.png";
import "../index.css"; // Import the CSS file

const Navbar = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <nav className="navbar">
      {currentUser ? (
        <>
          <Link to="/" className="nav-link">
            <img className="icon" src={SearchIcon} alt="Search" />
          </Link>
          <Link to="/add" className="nav-link">
            <img className="icon" src={AddIcon} alt="Add" />
          </Link>
          <Link to="/groups" className="nav-link">
            <img className="icon" src={UsersIcon} alt="Groups" />
          </Link>
          <div className="spacer"></div>
            <button onClick={handleLogout} className="logout-button">
              <img className="icon" src={LogoutIcon} alt="Logout" />
            </button>
        </>
      ) : (
        <Link to="/login" className="nav-link">Login</Link>
      )}
    </nav>
  );
};

export default Navbar;
